import script from "./MonthlyPriceTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./MonthlyPriceTooltip.vue?vue&type=script&setup=true&lang=js"

import "./MonthlyPriceTooltip.vue?vue&type=style&index=0&id=3bab2360&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bab2360"]])

export default __exports__